import { ViewEncapsulation } from '@angular/core';
import { Component } from '@angular/core';
import { PaginationModel } from '@spartacus/core';
import { ItemService, ListComponent, ListService } from '@spartacus/organization/administration/components';

@Component({
    selector: 'app-uig-unit-list',
    templateUrl: './uig-unit-list.component.html',
    styleUrls: ['./uig-unit-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigUnitListComponent<T = any, P = PaginationModel> extends ListComponent<T, P> {
  
  constructor(
    protected service: ListService<T, P>,
    protected organizationItemService: ItemService<T>
  ) {
    super(service,organizationItemService);
  }

}
